"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseAPI = void 0;

var axios_1 = __importDefault(require("axios"));

var httpClient = axios_1.default.create();

var BaseAPI = /*#__PURE__*/function () {
  function BaseAPI(url) {
    _classCallCheck(this, BaseAPI);

    this.url = url;
  }

  _createClass(BaseAPI, [{
    key: "request",
    value: function request(method, path) {
      var _this = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var axiosRequestConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var options = Object.assign(Object.assign({}, axiosRequestConfig), {
        method: method,
        url: this.getUrl(path)
      });

      if (params) {
        if (method === 'get') {
          options.params = params;
        } else {
          options.data = params;
        }
      }

      return httpClient.request(options).then(function (axiosResponse) {
        var _this$parseResponse = _this.parseResponse(axiosResponse),
            ok = _this$parseResponse.ok,
            data = _this$parseResponse.data,
            error = _this$parseResponse.error;

        return !ok || error ? Promise.reject({
          message: error,
          data: data
        }) : data;
      }).catch(function (error) {
        console.warn("[API] HTTP request failed: ".concat(error.message || ''), error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getUrl",
    value: function getUrl(path) {
      return "".concat(this.url).concat(path);
    }
  }, {
    key: "parseResponse",
    value: function parseResponse(axiosResponse) {
      var response = axiosResponse.data;

      if (typeof response.ok === 'boolean') {
        return response;
      }

      return {
        ok: true,
        data: response,
        error: ''
      };
    }
  }]);

  return BaseAPI;
}();

exports.BaseAPI = BaseAPI;